import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = ({ className = '', showLabel = false }) => {
  const { theme, setLightTheme, setDarkTheme, isDark } = useTheme();

  const handleThemeChange = (newTheme) => {
    if (newTheme === 'light') {
      setLightTheme();
    } else {
      setDarkTheme();
    }
  };

  return (
    <div className={`dropdown theme-toggle ${className}`}>
      <button
        className="btn btn-light dropdown-toggle d-flex align-items-center"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        title={`Current theme: ${theme}`}
      >
        <i className={`ti ${isDark ? 'ti-moon' : 'ti-sun'} ${showLabel ? 'me-2' : ''}`}></i>
        {showLabel && <span className="d-none d-lg-inline">{isDark ? 'Dark' : 'Light'}</span>}
      </button>
      <ul className="dropdown-menu dropdown-menu-end">
        <li>
          <button 
            className={`dropdown-item d-flex align-items-center ${theme === 'light' ? 'active' : ''}`}
            onClick={() => handleThemeChange('light')}
          >
            <i className="ti ti-sun me-2"></i>
            Light
          </button>
        </li>
        <li>
          <button 
            className={`dropdown-item d-flex align-items-center ${theme === 'dark' ? 'active' : ''}`}
            onClick={() => handleThemeChange('dark')}
          >
            <i className="ti ti-moon me-2"></i>
            Dark
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ThemeToggle;
